import { gql } from '@apollo/client';

/** mutation to create user comment for FFIEC009 rule */
export const CREATE_FFIEC009_USER_COMMENT = gql`
mutation createFFIEC009UserComment($input: CreateFFIEC009UserCommentInput) {
	createFFIEC009UserComment(input: $input)
}`;

/** mutation to update user comment for FFIEC009 rule */
export const UPDATE_FFIEC009_USER_COMMENT = gql`
mutation updateFFIEC009UserComment($input: UpdateFFIEC009UserCommentInput) {
	updateFFIEC009UserComment(input: $input)
}`;

/** mutation to delete user comment for FFIEC009 rule */
export const DELETE_FFIEC009_USER_COMMENT = gql`
mutation deleteFFIEC009UserComment($input: DeleteFFIEC009UserCommentInput) {
	deleteFFIEC009UserComment(input: $input)
}`;

/** mutation to classify audit log for FFIEC009 rule */
export const CREATE_CLASSIFY_AUDIT_LOGS_FOR_FFIEC009 = gql`
mutation createClassifyAuditLogForFFIEC009($input: ClassifyFFIEC009Input) {
	createClassifyAuditLogForFFIEC009(input: $input)
}`;
